var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowIcon = function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68098 4.78674L4.4801 1.71888C4.19781 1.4396 4.19781 0.988168 4.4801 0.708881C4.7631 0.429596 5.22118 0.429596 5.50347 0.708881L9.6827 4.74245C9.88709 4.94531 10 5.21317 10 5.50031C10 5.78674 9.88709 6.05602 9.6827 6.25745L5.50347 10.291C5.22118 10.5703 4.7631 10.5703 4.4801 10.291C4.19781 10.0125 4.19781 9.56031 4.4801 9.28102L7.67955 6.21531H0.714643C0.32016 6.21531 0 5.89531 0 5.50102C0 5.10674 0.32016 4.78674 0.714643 4.78674H7.68098Z",
    fill: "#2B81FC"
  })));
};
export default SvgArrowIcon;